import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { Customer, getStatusLabel, getValidTransitions } from "../../utils/commonTypes";
import { useLoginContext } from "../../utils/LoginContext";
import { useCustomerContext } from "../../utils/CustomerContext";
import { ChangeCustomerStateModal } from "./ChangeCustomerStateModal";

type Props = {
  customer: Customer;
};

export const CustomerHeader = ({ customer }: Props) => {
  const { authUser } = useLoginContext();
  const { updateCustomer } = useCustomerContext();
  const [isStateModalOpen, setStateModalOpen] = useState(false);

  const canModifyState =
    authUser.permissions.includes("PERMISSION_MODIFY_CUSTOMER_STATE") && getValidTransitions(customer.status).length > 0;

  return (
    <div>
      <div className="text-base">
        <b>Customer Details</b>
      </div>
      <div className="bg-white sm:rounded-md text-sm font-normal text-gray-800 mt-2">
        Name: <strong>{customer.userName}</strong>
        <br />
        Email: <strong>{customer.userEmail}</strong>
        <br />
        ID: <strong>{customer.customerId}</strong>
        <br />
        Status: <strong>{getStatusLabel(customer.status)}</strong>
        {canModifyState && (
          <button
            type="button"
            aria-label="Change customer state"
            onClick={() => setStateModalOpen(true)}
            style={{ marginLeft: "8px", cursor: "pointer", background: "none", border: "none", padding: 0 }}
          >
            <AiOutlineEdit />
          </button>
        )}
      </div>
      <ChangeCustomerStateModal
        isOpen={isStateModalOpen}
        customer={customer}
        onClose={() => setStateModalOpen(false)}
        onUpdated={updateCustomer}
      />
    </div>
  );
};
